import { render, staticRenderFns } from "./ScreeningQuestionIcon.vue?vue&type=template&id=c7285f34"
import script from "./ScreeningQuestionIcon.vue?vue&type=script&lang=ts"
export * from "./ScreeningQuestionIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports